import React from "react";
import * as icons from "@learningblocks/storybook-components/lib/Icons";
import { text_subs } from "./validator";
import { preloadedImage } from "../types";

class graphics {
  private static instance: graphics;
  private iconKeys: string[];
  private iconValues: string[];
  private preloadedImages: preloadedImage[];

  private constructor() {
    this.iconKeys = Object.keys(icons);
    this.iconValues = Object.values(icons);
    this.preloadedImages = [];
  }

  public static getInstance() {
    if (!this.instance) this.instance = new graphics();
    return this.instance;
  }

  preloadImage(image: string) {
    const source = this.iconValues[this.iconKeys.indexOf(image)];
    if (!source) {
      return;
    }

    // eslint-disable-next-line
    const newImage = new Image();
    newImage.src = source;

    const preloadedImage: preloadedImage = {
      key: image,
      image: newImage,
    };

    this.preloadedImages.push(preloadedImage);
  }

  // eslint-disable-next-line
  public loadImage(
    imageTag: string,
    altText: string,
    text_subs: text_subs[],
    userScale?: string | number,
    sceneScale?: string | number,
    objectScale?: string | number
  ) {
    //Use image tag to load the image with all tags
    let source = this.preloadedImages.find((img) => img.key == imageTag)?.image
      .src;
    if (!source) {
      source = this.iconValues[this.iconKeys.indexOf(imageTag)];
      if (!source) return;
    }
    return (
      <img
        src={source}
        style={{
          position: "relative",
        }}
        // data-user-scale={userScale}
        // data-scene-scale={sceneScale}
        data-object-scale={objectScale}
        data-text-subs={text_subs.map((sub) => sub.name).join(",")}
        alt={altText}
      ></img>
    );
  }

  public getImage(imageTag: string) {
    return this.iconValues[this.iconKeys.indexOf(imageTag)];
  }
}

export default graphics;
